import React from "react";
import { Route } from "react-router-dom";
import { DisconnectedLandingPage } from "./components/pages/LandingPage";
import Header from "./components/Header";

const AppLoading = () => {
  return (
    <div className="app app-content-container app--loading">
      <Header hideMenu />
      <div className="pageContainer">
        <Route
          exact={true}
          path="/guide"
          render={() => <DisconnectedLandingPage className="loading" />}
        />
      </div>
    </div>
  );
};

export default AppLoading;
